import { z } from 'zod';
export const demoToggleSchema = z.object({
    enabled: z.boolean(),
});
//# sourceMappingURL=demo.schemas.js.map